import SlotDefinition from "slotworks/model/slot-definition";

class AgsRecordUtils {

    public convertreelsToSlotworksGrid(reels: number[][]) {
        const grid = reels.map((reel) => reel.map((symbolIndex) => SlotDefinition.symbolDefinitions[symbolIndex].id));

        return grid;

    }
}
export default new AgsRecordUtils();
